import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';

export interface CompanyType {
    id: number,
    name: string,
    specify: boolean,
}

@Injectable()
export class CompanyTypeService {

    constructor(private http: Http) {}

    getAllCompanyTypes(): Observable<CompanyType[]> {
        return this.http.get('/api/client/dictionary/company-types').map(result => result.json())
            .map(result => {
                return result.types.map(type => {
                    return ({
                        id: type.id,
                        name: type.name,
                        specify: true
                    })
                })
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/+registration/api/dictionary/company-type.service.ts